import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Status } from 'features/battle/status'
import { Bet } from 'features/battle/bet'
import { Wheel } from 'features/battle/wheel'
import { Panel } from 'features/battle/panel'
import { stageSelector } from 'models/battle/selectors'
import { useSelector, useDispatch } from 'react-redux'
import { CSSTransition } from 'react-transition-group'
import { stageType } from 'features/battle/constants/stageType'
import { useEffect, useState } from 'react'
import { setStage } from 'models/battle'
import { battleService } from '../../core/services'

import c from './assets/sass/page.module.scss'
import { SupportIcon } from '../../ui/icons'

const BattlePage = () => {
    const { t } = useTranslation()
    const stage = useSelector(stageSelector)
    const dispatch = useDispatch()
    const [showWheel, setShowWheel] = useState(false)

    // При загрузке страницы проверяем текущую битву
    useEffect(() => {
        const checkBattle = async () => {
            try {
                console.log('🔍 Checking battle status on page mount...')
                const res = await battleService.getCurrentBattle()

                if (!res?.battle) {
                    console.log('ℹ️ No active battle, resetting to betting')
                    dispatch(setStage(stageType.betting))
                    window.battleSpunRef = false
                } else if (res.battle.status === 'FINISHED') {
                    console.log('✅ Battle is FINISHED, resetting to betting')
                    dispatch(setStage(stageType.betting))
                    window.battleSpunRef = false
                } else {
                    console.log('🎮 Active battle found:', res.battle.status)
                }
            } catch (error) {
                console.error('❌ Failed to check battle:', error)
                dispatch(setStage(stageType.betting))
                window.battleSpunRef = false
            }
        }
        checkBattle()
    }, [dispatch])

    useEffect(() => {
        // Wheel должен монтироваться сразу для получения socket событий
        if (stage !== stageType.betting && stage !== stageType.waiting) {
            setShowWheel(true)
        } else {
            setShowWheel(false)
        }
    }, [stage])

    const navigate = useNavigate()
    const handleFAQ = () => {
        navigate('/faq?category=modes')
    }

    return (
        <div className={c.component}>
            <div className={c.title}>
                <span className={c.mainTitle}>{t('battle.title')}</span>
                <span className={c.subTitle}>{t('battle.subtitle')}</span>
                <button type="button" className={c.btn} onClick={handleFAQ}>
                    <SupportIcon />
                </button>
            </div>
            <Status />
            <CSSTransition
                in={showWheel}
                timeout={300}
                classNames={{
                    enter: c.enter,
                    enterActive: c.enterActive,
                    exit: c.exit,
                    exitActive: c.exitActive,
                }}
                unmountOnExit
            >
                <Wheel />
            </CSSTransition>
            <CSSTransition
                in={showWheel}
                timeout={300}
                classNames={{
                    enter: c.enter,
                    enterActive: c.enterActive,
                    exit: c.exit,
                    exitActive: c.exitActive,
                }}
                unmountOnExit
            >
                <Panel />
            </CSSTransition>
            <CSSTransition
                in={stage === stageType.betting || stage === stageType.waiting}
                timeout={300}
                classNames={{
                    enter: c.enter,
                    enterActive: c.enterActive,
                    exit: c.exit,
                    exitActive: c.exitActive,
                }}
                unmountOnExit
            >
                <Bet />
            </CSSTransition>
        </div>
    )
}

export default BattlePage
